import gql from 'graphql-tag';

const GET_ORGS_BASIC_DETAILS = gql`
  query orgs($first: Int, $skip: Int, $orderBy: OrgOrderByInput, $where: OrgWhereInput) {
    orgs(first: $first, skip: $skip, orderBy: $orderBy, where: $where) {
      id
      domain
      name
      description
      level
      parentOrg {
        id
        name
      }
    }
  }
`;

export default GET_ORGS_BASIC_DETAILS;
